import React, { createContext, useContext, useState, useCallback } from 'react'

export interface MenuItem {
    name: string
    url: string
    children?: MenuItem[]
}

export type Menu = MenuItem[]

export interface SiteSettings {
    theme: 'light' | 'dark'
    experience: 'boring'
    compact: boolean
    showOptions: boolean
}

interface AppContextType {
    websiteMode: boolean
    siteSettings: SiteSettings
    setWindowTitle: (appWindow: any, title: string) => void
    setConfetti: (isActive: boolean) => void
    showContact: boolean
    setShowContact: (show: boolean) => void
    [key: string]: any
}

export const Context = createContext<AppContextType>({
    websiteMode: true,
    siteSettings: {
        theme: 'light',
        experience: 'boring',
        compact: false,
        showOptions: false,
    },
    setWindowTitle: () => null,
    setConfetti: () => {},
    showContact: false,
    setShowContact: () => {},
})

export const useApp = (): AppContextType => {
    const context = useContext(Context)
    if (!context) {
        return {
            websiteMode: true,
            siteSettings: {
                theme: 'light',
                experience: 'boring',
                compact: false,
                showOptions: false,
            },
            setWindowTitle: () => null,
            setConfetti: () => {},
        }
    }
    return context
}

export const Provider = ({
    children,
    element,
    location,
}: {
    children: React.ReactNode
    element?: any
    location?: any
}) => {
    const [siteSettings] = useState<SiteSettings>({
        theme: 'light',
        experience: 'boring',
        compact: false,
        showOptions: false,
    })

    const websiteMode = true

    const [confetti, setConfettiState] = useState(false)
    const setConfetti = useCallback((isActive: boolean) => {
        setConfettiState(isActive)
    }, [])

    const [showContact, setShowContact] = useState(false)

    const setWindowTitle = useCallback((_appWindow: any, _title: string) => {
        // No-op for marketing site - no desktop emulator windows
    }, [])

    return (
        <Context.Provider
            value={{
                websiteMode,
                siteSettings,
                setWindowTitle,
                setConfetti,
                showContact,
                setShowContact,
            }}
        >
            {children}
        </Context.Provider>
    )
}
